module.exports = __webpack_public_path__ + "img/wendewareAG.d49c4721.svg";